import { AuthActions, GlobalActions } from '@src/types/actions'
import { getType } from 'typesafe-actions'
import { resetState } from '../actions'
import {
  authFlowComplete,
  cheggAuthLoaded,
  handleCorruptToken,
  hideCheggAuthModal,
  SET_SELECTED_SCHOOL_TYPE,
  SET_SELECTED_USER_TYPE,
  setParsedJwt,
  setSuccessRedirect,
} from './actions'

import { AuthState } from './types'
export { AuthState }

export const initialState: AuthState = {
  cheggAuthLoaded: false,
  isInAuthFlow: false,
  successRedirect: null,
}

export default (
  state: AuthState = initialState,
  action: AuthActions | GlobalActions
): AuthState => {
  switch (action.type) {
    case getType(handleCorruptToken):
      const { jwt, ...remainingState } = state
      return remainingState
    case getType(setParsedJwt):
      return {
        ...state,
        jwt: action.payload,
      }
    case getType(cheggAuthLoaded):
      return {
        ...state,
        cheggAuthLoaded: true,
      }
    case 'auth/SHOW_AUTH_MODAL':
      return {
        ...state,
        isInAuthFlow: true,
      }
    case getType(hideCheggAuthModal):
    case getType(authFlowComplete):
      return {
        ...state,
        isInAuthFlow: false,
        selectedSchoolType: undefined,
        selectedUserType: undefined,
      }
    case SET_SELECTED_USER_TYPE:
      if (action.payload && action.payload.memberRole) {
        return {
          ...state,
          selectedUserType: action.payload.memberRole,
        }
      }
      return state
    case SET_SELECTED_SCHOOL_TYPE:
      if (action.payload && action.payload.schoolType) {
        return {
          ...state,
          selectedSchoolType: action.payload.schoolType,
        }
      }
      return state
    case getType(setSuccessRedirect): {
      return {
        ...state,
        ...action.payload,
      }
    }
    case getType(resetState): {
      return initialState
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/auth/reducer.ts